var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAppleIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 40,
    viewBox: "0 0 34 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.2439 9.36394C27.9438 9.36394 30.8058 10.8499 32.8438 13.4199C26.1639 17.1219 27.2499 26.7678 33.9998 29.3458C33.0698 31.4258 32.6258 32.3558 31.4298 34.1978C29.7598 36.7658 27.4098 39.9657 24.4919 39.9937C21.9019 40.0177 21.2359 38.2878 17.7199 38.3078C14.2039 38.3278 13.4699 40.0237 10.88 39.9997C7.96397 39.9717 5.73399 37.0838 4.064 34.5138C-0.603975 27.3298 -1.09197 18.8999 1.78801 14.4199C3.834 11.2319 7.05998 9.36594 10.096 9.36594C13.1859 9.36594 15.1279 11.0799 17.6839 11.0799C20.1639 11.0799 21.6719 9.36394 25.2439 9.36394ZM24.4599 0C24.8199 2.42998 23.8319 4.80997 22.5339 6.49396C21.1439 8.29795 18.7499 9.69594 16.4339 9.62394C16.0139 7.29795 17.0979 4.90397 18.4139 3.28998C19.8599 1.50999 22.3399 0.147999 24.4599 0Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppleIcon);
export default __webpack_public_path__ + "static/media/apple-icon.6634b4882a480d683e1ed3bf5e356a86.svg";
export { ForwardRef as ReactComponent };